import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { catchError, tap } from "rxjs/operators";
import { config } from '../config/config';
import { Icompetition } from '../model/Icompetition';
import { Isubcompetition } from '../model/Isubcompetition';
import { ICompetitionImage } from '../model/ICompetitionImage';
import { ICompetitionImageComment } from '../model/ICompetitionImageComment';
import { ICompetitionImageVote } from '../model/ICompetitionImageVote';
import { of } from 'rxjs';

@Injectable({
  providedIn: 'root'
})
export class CompetitionVotesService {

  constructor(private http: HttpClient) { }

  fetchCompetitions() {
    return this.http.get<any>(`${config['apiUrl']}/competition/fetchCompetitionVote?type=vote`);
  }

  fetchSubCompetitions(Id: number) {
    return this.http.get<any>(`${config['apiUrl']}/competition/fetchSubCompetition/` + Id, );
  }

  fetchCompetitionImages(sub: Isubcompetition) {
    return this.http.get<ICompetitionImage[]>(`${config['apiUrl']}/competition/fetchCompetitionImages/` + sub.CompetitionId + '/' + sub.Id + '?type=votes');
  }

  saveCompetitionImageComment(c: ICompetitionImageComment) {
    return this.http.post<ICompetitionImageComment>(`${config['apiUrl']}/competition/saveCompetitionImageComment`, c);
  }

  fetchCompetitionImageComment(CompetitionId: number, SubId: number, ImageId: number, UserId: number) {
    return this.http.post<ICompetitionImageComment>(`${config['apiUrl']}/competition/fetchCompetitionImageComment`, { CompetitionId: CompetitionId, SubId: SubId, ImageId: ImageId });
  }

  fetchCompetitionImageVote(CompetitionId: number, SubId: number, ImageId: number, UserId: number) {
    return this.http.post<ICompetitionImageVote>(`${config['apiUrl']}/competition/fetchCompetitionImageVote`, { CompetitionId: CompetitionId, SubId: SubId, ImageId: ImageId, UserId: UserId });
  }

  updateCompetitionVote(vote: ICompetitionImageVote) {
    return this.http.post<ICompetitionImageVote>(`${config['apiUrl']}/competition/updateCompetitionImageVote`, vote);
  }
}
